import classNames from 'classnames'
import * as React from 'react'

import IconArrowRight from '@/assets/specify/IconArrowRight'
import Link from '@/components/Link'

const themes = {
  primary: 'bg-purple-900 text-white group-hover/btn:bg-violet-600',
  secondary:
    'border border-purple-900 bg-transparent text-purple-900 group-hover/btn:border-violet-600 group-hover/btn:text-violet-600',
  tertiary:
    'misc-button-s text-purple-900 group-hover/btn:text-violet-600 group-focus:text-violet-600',
}

const buttonThemes = {
  primary: 'text-white bg-violet-600',
}

const sharedClassName = 'block text-center rounded-full button-m-bold'

const Button = ({
  as,
  className,
  label,
  children,
  link,
  obfuscate,
  id,
  hasIcon = true,
  theme = 'primary',
  size,
  onClick,
}) => {
  const Tag = as ?? Link

  return (
    <Tag
      link={link}
      id={id}
      className={classNames('group/btn relative flex', className)}
      obfuscate={obfuscate}
      onClick={onClick}
    >
      {hasIcon && theme === 'primary' && !size && (
        <span
          aria-hidden
          className={classNames(
            'absolute left-0 z-10 flex h-14 w-14 origin-left scale-100 items-center justify-center transition-all duration-300 ease-out group-hover/btn:scale-0 group-focus:scale-0',
            sharedClassName,
            buttonThemes[theme]
          )}
        >
          <span className='rotate-0 transition-all duration-500 ease-out group-hover/btn:rotate-45 group-focus:rotate-45'>
            <IconArrowRight />
          </span>
        </span>
      )}
      {theme === 'email' ? (
        <div className='flex items-center'>
          <span
            className={classNames(
              'misc-button-s p-2 text-white opacity-25 group-hover/btn:text-purple-900 group-focus:text-purple-900',
              sharedClassName
            )}
          >
            {label || children}
          </span>
          <div className='relative z-30 flex h-10 w-10 items-center  justify-center rounded-xl bg-white bg-opacity-25 p-2 text-purple-400 group-hover/btn:bg-violet-600 group-hover/btn:text-violet-300 group-focus:bg-violet-600 group-focus:text-violet-300'>
            <IconArrowRight />
          </div>
        </div>
      ) : (
        <span
          className={classNames(
            {
              'relative translate-x-14 transition-all duration-300 ease-out group-hover/btn:translate-x-0 group-focus:translate-x-0':
                theme === 'primary' && hasIcon && !size,
            },
            {'w-full': !hasIcon},
            size === 'small' ? 'misc-button-s px-6 py-2' : 'misc-button-m px-8 py-4',
            sharedClassName,
            themes[theme]
          )}
        >
          {label || children}
        </span>
      )}

      {hasIcon && theme === 'primary' && !size && (
        <span
          aria-hidden
          className={classNames(
            'relative flex w-14 origin-right scale-0 items-center justify-center transition-all duration-300 ease-out group-hover/btn:scale-100 group-focus:scale-100',
            sharedClassName,
            buttonThemes[theme]
          )}
        >
          <span className='rotate-0 transition-all duration-500 ease-out group-hover/btn:rotate-45 group-focus:rotate-45'>
            <IconArrowRight />
          </span>
        </span>
      )}
    </Tag>
  )
}

export default Button
